import classNames from "shared/utils/classNames";

type Props = {
  className?: string;
};

export function LoadingSpinner(props: Props) {
  const { className = "" } = props;
  const sharedClassName = classNames(
    "absolute border-2 border-solid",
    className,
  );

  return (
    <>
      <div
        className={classNames(
          sharedClassName,
          "h-full w-full rounded-2xl opacity-25",
        )}
      />
      <div
        className={classNames(
          sharedClassName,
          "h-full w-full rounded-2xl",
          "animate-spin border-r-transparent",
        )}
      />
    </>
  );
}

export default LoadingSpinner;
